// eslint-disable-next-line
export const sessionIdSelector = (state) => state.getIn(['authorization', 'sessionId'])
